export default {
	default: [''],
	primary: ['btn-classic--primary'],
	secondary: ['btn-classic--secondary'],
	text: ['btn-classic--text']
};
